import React from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Typography, Box, Paper } from '@mui/material';
import { changeNameStep } from 'utils/changeNameStep';
import { formatDateAndHoursToBrazilian } from 'utils/date-time.utils';
import { useSelector } from 'react-redux';
import { STEPS_INQUIRY } from 'constants/inquirys/stepsInquiry';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    height: '100%',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
  textsimple: {
    wordWrap: 'break-word',
  },
  divDate: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const ButtonTimeline = props => {
  const { transition, events } = props;

  const customerConfig = useSelector(state => state.customerConfig);

  const classes = useStyles();

  return (
    <Paper elevation={2} className={classes.root}>
      <Box display="flex" flexDirection="row" width="100%" alignItems="flex-start">
        <Box flex={1}>
          <Box className={classes.textsimple} style={{ display: 'flex' }}>
            <Typography variant="h6" className={classes.textsimple}>
              {changeNameStep(transition.toStep, customerConfig)}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.divDate} ml={3}>
          <Typography variant="h6" className={classes.textsimple}>
            {formatDateAndHoursToBrazilian(transition.createdAt)}
            {transition.createdByUser?.name
              ? ` - Realizado por: ${transition.createdByUser.name}`
              : ''}
          </Typography>
        </Box>
      </Box>
      <Box mt={2} width="100%">
        {events &&
          events.length > 0 &&
          events.map(item => (
            <Typography key={item.description} variant="h6" className={classes.textsimple}>
              {formatDateAndHoursToBrazilian(item.date)} - {item.description}{' '}
              {item.executedBy && `- Realizado por: ${item.executedBy}`}
            </Typography>
          ))}
        <Typography variant="h6" className={classes.textsimple}>
          {transition.justification === 'proxima_fase' ||
          [STEPS_INQUIRY.TERMO_DE_ENCAMINHAMENTO, STEPS_INQUIRY.CUMPRIMENTO_ACORDO].includes(
            transition?.toStep,
          )
            ? ''
            : transition.justification}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ButtonTimeline;
